import { render, staticRenderFns } from "./imodalEditPriorAutho.vue?vue&type=template&id=03590424&"
import script from "./imodalEditPriorAutho.vue?vue&type=script&lang=js&"
export * from "./imodalEditPriorAutho.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports